import "./Footer.scss";
import SocialIcons from "../SocialIcons/SocialIcons";
import logo from "../../image/logotype/logo.svg";
import { Link } from "react-router-dom";

export default function Footer() {

    return (
        <footer className="footer footer__container">
            <div className="contain__block">
                <div>
                    <div className="footer__img">
                        <Link to="/">
                            <img className="TM" src={logo} alt="logo" />
                        </Link>
                        <Link to="/">
                            <div className="header__logo-title">
                                <span className="footer__text-under">САНБЕРРІ УКРАЇНА</span>
                            </div>
                        </Link>
                    </div>
                    <div className="contain__mail">
                        <p className="copywriting__title">2014-2026 © Санберрі Україна. Всі права захищені.</p>
                    </div>
                </div>
                <div className="footer__navigation-container">
                    <div className="contain__navigation--position">
                        <h2 className="contain__subtitle">Каталог товарів</h2>
                        <Link to="catalog">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Продукція</p>
                        </Link>
                        <Link to="catalogSeed">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Насіння</p>
                        </Link>
                        <Link to="culture">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Культура</p>
                        </Link>
                        <Link to="blog">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Блог</p>
                        </Link>
                        <Link to="innovation">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Інновації</p>
                        </Link>
                        <Link to="distributors">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Дистриб'юція</p>
                        </Link>
                        <Link to="partners">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Партнери</p>
                        </Link>
                        <a className="navigation__link navigation__link-weight navigation__link--color" href="https://sun-ukr.vn.ua/" target="_blank" rel="noopener noreferrer">
                            Магазин
                        </a>
                        <Link to="contact">
                            <p className="navigation__link navigation__link-weight navigation__link--color">Контакти</p>
                        </Link>
                    </div>
                    <div className="contain__navigation--position">
                        <h2 className="contain__subtitle">Клієнтам</h2>
                        <Link className="navigation__link navigation__link-weight navigation__link--color" to="oplata-ta-dostavka">
                            <span>Оплата і доставка</span>
                        </Link>
                        <Link className="navigation__link navigation__link-weight navigation__link--color" to="obmin-ta-povernennya">
                            <span>Обмін та повернення</span>
                        </Link>
                        <Link className="navigation__link navigation__link-weight navigation__link--color" to="public-Offer">
                            <span>Публічна оферта</span>
                        </Link>
                        <Link className="navigation__link navigation__link-weight navigation__link--color" to="privacy">
                            <span>Політика конфіденційності</span>
                        </Link>
                    </div>
                    <div className="contain__navigation--position">
                        <h2 className="contain__subtitle">Контакти</h2>
                        <span className="navigation__link navigation__link-weight navigation__link--color">м. Вінниця, вулиця Сергія Зулінського, 43</span>
                        <a className="navigation__link navigation__link-weight navigation__link--color" href="tel:+380683699030">+38(068)-369-90-30</a>
                        <a className="navigation__link navigation__link-weight navigation__link--color" href="mailto:sunberry.ukr@gmail.com"> sunberry.ukr@gmail.com</a>
                    </div>
                </div>
                <div className="footer__right">
                    <h2 className="contain__subtitle">Зв’язатися з нами</h2>
                    <div className="footer__icons">
                        <SocialIcons />
                    </div>
                    <div className="contain__time time">
                        <span className="time__work">Графік роботи:</span>
                        <div className="contain__work">
                            <div className="contain__work-time">
                                <span>Пн-Пт:</span>
                                <span>09:00–17:00</span>
                            </div>
                            <div className="contain__work-time">
                                <span>Сб-Нд:</span>
                                <span>вихідний</span>
                            </div>
                        </div>
                    </div>
                    <div className="contain__privacy">
                        <p className="copywriting__title">2014-2026 © Санберрі Україна. Всі права захищені.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
